import { IMainPageAction, TMainPageState } from '../../types/mainpage';
import { MAINPAGE_DEFAULT_STATE } from '../../constants/mainpage/defaultState';
import { EXPERIMENTS_GET_SUCCESS, GET_NEWBUILDING_RECOMMENDATIONS } from '../modules/mainpage';

const defaultAction: IMainPageAction = {
  type: '',
};

export function mainpageReducer(state = MAINPAGE_DEFAULT_STATE, action = defaultAction): TMainPageState {
  switch (action.type) {
    case EXPERIMENTS_GET_SUCCESS:
      return Object.assign({}, state, {
        experiments: action.experiments,
      });

    case GET_NEWBUILDING_RECOMMENDATIONS:
      return {
        ...state,
        newbuilding_recommendations: action.newbuilding_recommendations
          ? [...action.newbuilding_recommendations]
          : [...state.newbuilding_recommendations],
      };

    default:
      return state;
  }
}
